export default function ($translate) {
    return {
        KEYS: {
            DEPARTMENT: 'DEPARTMENT',
            PERSONAL: 'PERSONAL'
        },
        LABELS: {
            DEPARTMENT: $translate.instant('budget.Department type'),
            PERSONAL: $translate.instant('budget.Personal type')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/budget/index.js